import { all } from 'redux-saga/effects';
import authSaga from './authSaga';
import logoSaga from './logoSaga';
import oemSaga from './oemSaga';
import profileSaga from './profileSaga';
import customerSaga from './customerSaga';
import transactionSaga from './transactionSaga';
import multipleDomainSaga from './multipleDomainSaga';
import scanSaga from './myDomainScanSaga';
import scanListSaga from './scanListSaga';
import singleScanSaga from './singleScanSaga';
import dashboardSaga from './dashboardSaga/dashboardSaga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    logoSaga(),
    oemSaga(),
    profileSaga(),
    customerSaga(),
    transactionSaga(),
    multipleDomainSaga(),
    scanSaga(),
    scanListSaga(),
    singleScanSaga(),
    dashboardSaga()
  ]);
}